import React, { FC, useState, useEffect, useRef } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent } from '@ionic/react'
import { UseHeader, MktEmpty, CouponSuccModal, TipModal } from '@cps'
import { memberMobx } from '@mobxStore'
import { modalLayer, useHistoryNew, waterfall } from '@utils'
import { MemberApi } from '@api/index'
import { find, orderBy, findIndex } from '@dt/fe-utils/dist/lodash'
import { ProductItem } from 'pages/mkt/components'
import ProductDetail from '../components/ProductDetail'
import mktController from 'controllers/mktController'
import './index.scss'

import BgCard from '@img/member/card-dark-bg.jpg'
import NoRedeemImg from '@img/no-redeem.png'

interface IProps extends IPage, RouteComponentProps { }

const CouponPage: FC<IProps> = ({ match }) => {
  const { cardId } = match.params as any
  const history = useHistoryNew()
  const { cardList } = memberMobx
  const [listInfo, setListInfo] = useState<any[]>([])
  const [selectCard, setSelectCard] = useState<any>(null)
  const [proList, setProList] = useState<any[]>([])
  const [selectIndex, setSelectIndex] = useState<number>(0)
  const refDom = useRef<any>(null)
  const goDetail = (proInfo: any) => {
    modalLayer(ProductDetail, { info: proInfo, cardInfo: selectCard }).then((res: any) => {
      getData()
      if (res.error) {
        let text: string
        if (res.code === 4006) {
          // 无兑换资格 即商城不再关联此卡
          text = i18n.t('mkt.redeem.buyFailTip1')
        } else if (res.code === 4012) {
          // 商品下架 找不到
          text = i18n.t('mkt.redeem.buyFailTip2')
        } else if (res.code === 4013) {
          // 不在售卖时间
          text = i18n.t('mkt.redeem.buyFailTip3')
        } else if (res.code === 4014) {
          // 积分不足
          text = i18n.t('mkt.redeem.buyFailTip4')
        } else if (res.code === 4015) {
          // 商品售罄
          text = i18n.t('mkt.redeem.buyFailTip5')
        } else {
          // 其他原因购买失败
          text = i18n.t('mkt.redeem.buyFailTip')
        }
        modalLayer(TipModal, {
          title: i18n.t('mkt.redeem.buyFail'),
          content: text
        })
      } else {
        modalLayer(CouponSuccModal, {
          name: res.name,
          title: i18n.t('mkt.redeem.succRedeem'),
          des: i18n.t('mkt.redeem.getCouponsNumber', { cnt: res.cnt })
        })
      }
    }, () => {
      getData()
    })
  }
  const getData = () => {
    MemberApi.getRedeemProduct({ memberCardId: selectCard.memberCardId }).then((res: any) => {
      setProList(orderBy(res, (item: any) => item.seqencing))
    })
  }
  // Component Effect
  useEffect(() => {
    if (selectCard) {
      getData()
    }
  }, [selectCard])
  useEffect(() => {
    const resultList: any[] = cardList.sort((a: any, b: any) => b.integral - a.integral)
    setListInfo(resultList)
    if (selectCard) {
      const findCard: any = find(cardList, (item: any) => item.memberCardId === selectCard.memberCardId)
      setSelectCard(findCard)
    } else {
      if (cardId) {
        const hasItem = findIndex(cardList, (m: IMemberCardInfo) => `${m.cardId}` === cardId)
        setSelectCard(resultList[hasItem])
        setSelectIndex(hasItem)
      } else {
        setSelectCard(resultList[0])
      }
    }
  }, [cardList])
  useEffect(() => {
    if (refDom?.current && selectIndex) {
      setTimeout(() => {
        refDom.current?.scrollBy(refDom.current.scrollWidth / listInfo.length * selectIndex - 32, 0)
      }, 200)
    }
  }, [listInfo, selectIndex])

  // 瀑布流实现
  useEffect(() => {
    const timer = setTimeout(() => {
      waterfall('water-fall-container', proList.length, 12)
    }, 0)
    return () => clearTimeout(timer)
  }, [proList])
  return (
    <IonPage className='redeem-page'>
      <UseHeader title={i18n.t('mkt.redeem.pointRedeem')} onBack={() => mktController.goBack(history)}></UseHeader>
      <IonContent className='page-content'>
        <div className='page-body'>
          <div className='card-area' ref={refDom}>
            {
              listInfo.map((item: any) => {
                return (
                  <div data-cypid='mmgRedeemMCardItem' className={`redeem-card-item${selectCard && selectCard.memberCardId === item.memberCardId ? ' selected' : ''}${listInfo.length === 1 ? ' card-item-one' : ''}`} key={item.memberCardId} style={{ backgroundImage: `url(${item.card.cover || BgCard})`, color: item.card?.extra?.fontColor || '#f0cda8' }} onClick={() => setSelectCard(item)}>
                    <div className='card-name'>{item.card.cardName}</div>
                    <div className='card-inter'><span style={{ color: item.card?.extra?.fontColor || '#f0cda8' }}>{item.integral}</span> {i18n.t('mkt.common.integral')}</div>
                    {selectCard && selectCard.memberCardId === item.memberCardId ? <div className='select-tip'></div> : <div className='no-select-tip'></div>}
                  </div>
                )
              })
            }
          </div>
          {proList.length === 0 && <MktEmpty img={NoRedeemImg} text={i18n.t('mkt.redeem.noRedeemGoods')} onClick={() => mktController.goBack(history)} />}
          <div className='pro-area'>
            <div className='water-fall-container'>
              {
                proList.map((item: any) => (
                  <div className='pro-block' key={item.redeemProductId}>
                    <ProductItem
                      showSoldNum={memberMobx.brandConfig.isShowRedeemIntegralSale}
                      info={item} onDetail={() => goDetail(item)}
                    >
                    </ProductItem>
                  </div>)
                )
              }
            </div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(CouponPage)
